import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate, useLocation } from "react-router-dom";

import Menu from "../components/menu";
import Api from "../libs/api";
import Storage from "../libs/storage";
import Content from "../components/content";
import { useImpersonation } from "../global/impersonation";
import MessageNotice from "../components/message_notice";
import { useMessages } from "../global/messagesContext";
import ToastUpdatePlan from "../components/modalUpdatePlan/toastUpdatePlan";
import ModalAcceptTerms from "../components/modalAcceptTerms";

const Holder = styled.div`
    display: flex;
    height: 100%;
    position: fixed;
    width: 100%;
    left: 0px;
    top: 0px;
    margin-top: ${({ hasImpersonationTitle }) =>
        hasImpersonationTitle ? "0" : "0"};
`;

const MenuHolder = styled.div`
    position: relative;
    height: 100%;
    overflow: hidden;
    transition: 0.4s;
`;

const MenuHolderMobile = styled.div`
    position: fixed;
    height: 100%;
    max-width: 100%;
    overflow: scroll;
    left: 0px;
    top: 0px;
    z-index: 99;
    width: 400px;
    filter: drop-shadow(0 0 0.75rem #ddd);
    transition: 0.4s;
`;

const ScreenHolder = styled.div`
    position: relative;
    height: 100%;
    overflow: scroll;
    transition: 0.4s;
`;

const MobileMenu = styled.div`
    height: 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 56px 0px 0px;
`;

const MenuHamburgerHolder = styled.div`
    width: 32px;
    height: 32px;
    cursor: pointer;
`;

const Logo = styled.img`
    width: 42px;
`;

export default function Wrapper({ screen }) {
    let api = Api();
    let storage = Storage();
    let navigate = useNavigate();
    let location = useLocation();
    const { isImpersonate } = useImpersonation();
    const { showMessageNotice } = useMessages();
    const [width, setWidth] = useState(window.innerWidth);
    const [companyName, setCompanyName] = useState();
    const [profile, setProfile] = useState();
    const [currentRoute, setCurrentRoute] = useState(location.pathname);
    const [open, setOpen] = useState(false);
    const [hover, setHover] = useState(false);
    // const [shouldShowUpdatePlan, setShouldShowUpdatePlan] = useState(false);
    const [currentFreePlan, setCurrentFreePlan] = useState(null);
    const [hasNewPlan, setHasNewPlan] = useState(false);
    const [showModalAcceptTerms, setShowModalAcceptTerms] = useState(false);
    const [activeUsersCount, setActiveUsersCount] = useState(0);
    const [acceptedTerms, setAcceptedTerms] = useState(false);
    const [storageAcceptedTerms, setStorageAcceptedTerms] = useState(false);
    const [enablePayments, setEnablePayments] = useState(null);
    const [companyId, setCompanyId] = useState(null);

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

    const getProfile = async () => {
        const data = await storage.getItem("data");
        if (!data) {
            navigate("/login");
            return;
        }

        let response = await api.getProfile(data.token);
        if (response.error || response.data.profile.profile.role === 0) {
            navigate("/login");
            return;
        }

        let userProfile = response.data.profile.profile;

        userProfile["permissions"] = userProfile.permissions || {};

        setCompanyName(userProfile?.company?.name);
        setProfile(userProfile);
        setActiveUsersCount(userProfile?.company?.activeUsersCount);
        setStorageAcceptedTerms(userProfile?.company?.acceptTermsOfUse);

        await storage.saveItem("data", {
            ...data,
            profile: { ...userProfile },
        });

        const activeUsersCountResponse = await api.getActiveUsersCount(
            data.token
        );
        const newActiveUsersCount =
            activeUsersCountResponse?.data?.activeUsersCount || 0;
        const recurringPlanId = userProfile?.company?.recurringPlanId || "free";
        const enablePaymentsValue =
            userProfile?.company?.enablePayments || false;
        const currentFreePlanValue =
            recurringPlanId === "free" && newActiveUsersCount < 4;
        const hasNewPlan = recurringPlanId !== "free";

        setCompanyName(userProfile?.company?.name);
        setProfile(userProfile);
        setStorageAcceptedTerms(userProfile?.company?.acceptTermsOfUse);
        setActiveUsersCount(newActiveUsersCount);
        setEnablePayments(enablePaymentsValue);
        setCurrentFreePlan(currentFreePlanValue);
        setHasNewPlan(hasNewPlan);
        const decodedId = parseInt(
            atob(userProfile?.company?.id).split(":")[1],
            10
        );
        setCompanyId(decodedId);
    };

    useEffect(() => {
        getProfile();
        setCurrentRoute(location.pathname);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    useEffect(() => {
        getProfile();
        window.addEventListener("resize", handleWindowSizeChange);
        window.addEventListener("load", handleWindowSizeChange);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (activeUsersCount > 19 && !storageAcceptedTerms) {
            setShowModalAcceptTerms(true);
        }
    }, [activeUsersCount, storageAcceptedTerms]);

    // Checar a data 01/02/2026 para esconder o banner de não habilitados em pagamentos
    const shouldShowToast = () => {
        if (companyId === 1127 || companyId === 8730) {
            // Ocultar para empresa BBraun * A SEGUNDA É TESTE DE UMA EMPRESA MINHA, DELETAR FUTURAMENTE
            return false;
        }
        if (hasNewPlan) {
            return false; // Se já tem um novo plano, não mostrar o toast
        }
        const isAfterJanuary16 =
            new Date() >= new Date("2026-02-01T00:00:00-03:00");

        if (isAfterJanuary16 && !enablePayments) {
            return false;
        }
        return enablePayments !== null || currentFreePlan !== null;
    };

    const showToast = shouldShowToast();

    return (
        <>
            <MessageNotice currentRoute={currentRoute} />
            {showToast && (
                <ToastUpdatePlan
                    currentFreePlan={currentFreePlan}
                    enablePayments={enablePayments}
                />
            )}
            <ModalAcceptTerms
                showModal={showModalAcceptTerms}
                setShowModal={setShowModalAcceptTerms}
                activeUsersCount={activeUsersCount}
                acceptedTerms={acceptedTerms}
                setAcceptedTerms={setAcceptedTerms}
            />
            <Holder
                style={{
                    paddingTop: showToast ? (width < 700 ? 90 : 56) : 0,
                }}
                hasImpersonationTitle={isImpersonate}
            >
                <MenuHolder
                    style={{
                        width: width >= 1280 ? (hover ? 408 : 110) : 0,
                        paddingTop:
                            showMessageNotice && currentRoute !== "/notice"
                                ? 72
                                : 0,
                    }}
                    onMouseEnter={() => {
                        setHover(true);
                    }}
                    onMouseLeave={() => {
                        setHover(false);
                    }}
                >
                    <Menu
                        floater={true}
                        showClose={false}
                        profile={profile}
                        companyName={companyName}
                    />
                </MenuHolder>
                <ScreenHolder
                    style={{
                        width:
                            width >= 1280 ? width - (hover ? 408 : 110) : width,
                        paddingTop:
                            showMessageNotice && currentRoute !== "/notice"
                                ? 72
                                : 0,
                    }}
                >
                    {width < 1280 && (
                        <Content padding={32}>
                            <MobileMenu>
                                <MenuHolderMobile
                                    style={{ left: open ? 0 : -400 }}
                                >
                                    <Menu
                                        showClose={true}
                                        setOpen={setOpen}
                                        profile={profile}
                                    />
                                </MenuHolderMobile>
                                <MenuHamburgerHolder>
                                    <img
                                        src="/img/hamburger.svg"
                                        alt="Menu"
                                        onClick={() => {
                                            setOpen(!open);
                                        }}
                                    />
                                </MenuHamburgerHolder>
                                <Logo src="/img/logo.png" />
                                <MenuHamburgerHolder />
                            </MobileMenu>
                        </Content>
                    )}
                    {React.cloneElement(screen, { refreshProfile: getProfile })}
                </ScreenHolder>
            </Holder>
        </>
    );
}
